import { useStore } from "vuex";
import { User } from "../types/User";

export const useUser = () => {
  const store = useStore();
  return store.state.user as User | undefined;
};
